import styled from 'styled-components'

export const ContactPerson = styled.div`
  margin-top: 10px;

  .contact-person-name {
    margin-bottom: 10px;
  }

  [class^='contact-person-'] {
    margin-bottom: 5px;
    a {
      text-decoration: none;
    }
  }

  [class^='contact-person-']:last-child {
    margin-bottom: 15px;
  }
`

export const ContactIcon = styled.span`
  color: ${ (props) => props.theme.colors['icon-grau1'] };
  margin-right: 11px;
`
